import React, { useEffect, useState } from "react";
import EmailIcon from "@mui/icons-material/Email";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import PhoneIcon from "@mui/icons-material/Phone";
import { Box, TableCell, TableRow } from "@mui/material";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import * as Sentry from "@sentry/react";
import {
  FRIEND_TRANSFER_REMARK_COL,
  FRIEND_TRANSFER_TABLE_COL,
} from "../../../contants/table/friendTransfer";
import tableStyle from "../../../theme/styles/table";
import styles from "./style";
import PendingTab from "../../../components/PendingTab";

import { ROUTES } from "../../../utils/constants";
import { convertDateTimeToDate } from "../../../utils/dateAndTime";
import Member from "../../../services/api/member";
import {
  forwardMember,
  rejectMember,
  acceptMember,
} from "../../../redux/actions/member";
import { MEMBER_TYPE } from "../../../contants";
import Table from "../../../components/common/new/Table/Table";

const getRows = (data) =>
  data.map((friendInfo) => (
    <TableRow style={tableStyle.tableRow}>
      <TableCell> {friendInfo.fullName} </TableCell>
      <TableCell>
        <LocationOnIcon style={tableStyle.locationIcon} />{" "}
        {friendInfo.addressLine1}
      </TableCell>
      <TableCell sx={{ maxWidth: "12rem" }}>
        <PhoneIcon style={tableStyle.icon} /> {friendInfo.mobileNumber} <br />
        <>
          {" "}
          <EmailIcon style={tableStyle.icon} /> {friendInfo?.emailId || "-"}{" "}
        </>
      </TableCell>
      <TableCell>
        {friendInfo?.targetOrganizationStructure?.targetOrgArea || "-"}{" "}
      </TableCell>
      <TableCell>
        {friendInfo?.targetOrganizationStructure?.targetOrgCluster || "-"}{" "}
      </TableCell>
      <TableCell>
        {friendInfo?.targetOrganizationStructure?.targetOrgZone || "-"}{" "}
      </TableCell>
      <TableCell>
        {friendInfo?.targetOrganizationStructure?.targetOrgRegion || "-"}{" "}
      </TableCell>
      <TableCell>
        {friendInfo?.targetOrganizationStructure?.targetOrgChapter || "-"}{" "}
      </TableCell>
      <TableCell>
        {friendInfo?.targetOrganizationStructure?.targetOrgDistrict || "-"}{" "}
      </TableCell>
    </TableRow>
  ));

const getRemarkRows = (data) =>
  data.map((remarker, index) => (
    <TableRow style={tableStyle.tableRow}>
      <TableCell>{index + 1}. </TableCell>
      <TableCell sx={{ display: "flex" }}>
        <Box
          component="img"
          sx={{
            height: 22,
            width: 22,
            borderRadius: "50%",
            marginRight: ".5rem",
          }}
          alt="The house from the offer."
          src="https://images.unsplash.com/photo-1512917774080-9991f1c4c750?auto=format&w=350&dpr=2"
        />{" "}
        {remarker?.updatedByUser?.fullName}{" "}
      </TableCell>
      <TableCell>{remarker.data.message} </TableCell>
      <TableCell>{convertDateTimeToDate(remarker?.createdAt)}</TableCell>
    </TableRow>
  ));

export default function MemberTransfer() {
  const [remarksData, setRemarksData] = useState([]);
  const navigate = useNavigate();
  const selectedMember = useSelector(
    (store) => store.view_members.selectedMemberPendingTransfer
  );

  const getRemarksData = async (member) => {
    try {
      const response = await Member.getMemberRemarks({
        id: member.transferId,
      });
      setRemarksData(response.data);
    } catch (error) {
      Sentry.captureException(error);
    }
  };

  if (selectedMember && !Object.keys(selectedMember).length) {
    navigate(`/${ROUTES.MEMBER_TRANSFER.path}`);
  }

  useEffect(() => {
    getRemarksData(selectedMember);
  }, [selectedMember]);

  const refreshRemarks = () => {
    getRemarksData(selectedMember);
  };

  return (
    <Box sx={styles.container} mx={5} mb={5}>
      <Table
        columns={FRIEND_TRANSFER_TABLE_COL}
        rows={getRows([selectedMember])}
      />
      <PendingTab
        firstTabTitle="Assign To"
        secondTabTitle="Reject Transfer"
        selectedItem={selectedMember}
        onFinalSubmit={forwardMember}
        onFinalReject={rejectMember}
        pageType={MEMBER_TYPE}
        refreshRemarks={refreshRemarks}
        onFinalAccept={acceptMember}
      />
      <Table
        columns={FRIEND_TRANSFER_REMARK_COL}
        rows={getRemarkRows(remarksData)}
      />
    </Box>
  );
}
